import React from "react";
import { ReactComponent as Star1 } from "../../assets/logosSvg/Star 1.svg";
import { ReactComponent as Star2 } from "../../assets/logosSvg/Star 2.svg";
import { ReactComponent as Logo } from "../../assets/logosSvg/logoEasyBI.svg";
import { alpha, Stack, useTheme } from "@mui/system";

interface LoadingProps {
  size?: number;
}

const Loading = ({ size = 50 }: LoadingProps) => {
  const theme = useTheme();

  const styles = {
    common: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
    zoom: {
      width: "50%",
      height: "50%",
      fill: theme.palette.text.primary,
      animation: "zoom 3s linear infinite",
    },
    spinner: {
      width: "100%",
      height: "100%",
      stroke: theme.palette.primary.main,
      animation: "spin 3s linear infinite",
      zIndex: 100,
    },
    spinnerAnt: {
      width: "90%",
      height: "90%",
      stroke: alpha(theme.palette.background.textField, 1),
      animation: "antspin 3s linear infinite",
    },
    stack: {
      position: "relative",
      width: size + "px",
      height: size + "px",
      justifyContent: "center",
      alignItems: "center",
      margin: "1rem",
    },
    keyframes: `
      @keyframes spin {
        from { transform: translate(-50%, -50%) rotate(0deg); }
        to { transform: translate(-50%, -50%) rotate(360deg); }
      }
      @keyframes antspin {
        from { transform: translate(-50%, -50%) rotate(360deg); }
        to { transform: translate(-50%, -50%) rotate(0deg); }
      }
      @keyframes zoom {
          0% {
              transform: translate(-50%, -50%) scale(1);
          }
          50% {
              transform: translate(-50%, -50%) scale(1.2);
          }
          100% {
              transform: translate(-50%, -50%) scale(1);
          }
      }
    `,
  };

  return (
    <Stack sx={styles.stack}>
      <style>{styles.keyframes}</style>
      <Star1
        style={{ ...styles.common, ...styles.spinner } as React.CSSProperties}
      />
      <Star2
        style={
          { ...styles.common, ...styles.spinnerAnt } as React.CSSProperties
        }
      />
      <Logo
        style={{ ...styles.common, ...styles.zoom } as React.CSSProperties}
      />
    </Stack>
  );
};

export default Loading;
